<template>
  <pt-work-order-history class="pt-work-order-history__page"></pt-work-order-history>
</template>

<script>
import PtWorkOrderHistory from 'cps/work-order/pt-consulting-subscribe-order/pt-work-order-history/withData'
export default {
  name: 'pt-work-order-history__view',
  components: {
    'pt-work-order-history': PtWorkOrderHistory
  }
}
</script>
